import { render, staticRenderFns } from "./RaceChart.vue?vue&type=template&id=328ad4db"
import script from "./RaceChart.vue?vue&type=script&lang=js"
export * from "./RaceChart.vue?vue&type=script&lang=js"
import "./RaceChart.vue?vue&type=style&index=0&id=328ad4db&prod&lang=scss"
/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports